import { render, staticRenderFns } from "./promptModal.vue?vue&type=template&id=71c9817b&scoped=true&"
import script from "./promptModal.vue?vue&type=script&lang=js&"
export * from "./promptModal.vue?vue&type=script&lang=js&"
import style0 from "./promptModal.vue?vue&type=style&index=0&id=71c9817b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c9817b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VDialog})
